var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background-Complete",
    transform: "matrix(1.21068,0,0,1.21068,-122.954,-4.83037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,538.443,-287.307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.964,
    y: 313.895,
    width: 88.515,
    height: 146.517,
    style: {
      fill: "rgb(225,225,225)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,532.555,-287.307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.02,
    y: 313.895,
    width: 88.515,
    height: 146.517,
    style: {
      fill: "rgb(236,236,236)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,532.555,-287.307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.789,
    y: 316.866,
    width: 80.977,
    height: 140.575,
    style: {
      fill: "rgb(250,250,250)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,532.204,-287.308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.205,
    y: 335.133,
    width: 49.794,
    height: 104.042,
    style: {
      fill: "rgb(236,236,236)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,408.205,113.484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.566C-0.115,-8.153 8.624,-17.641 18.248,-18.997C22.837,-19.645 27.713,-18.734 32.001,-20.493C39.655,-23.631 42.091,-33.801 49.794,-36.817L50.146,38.383L0,38.383L0,1.566Z",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.784047,-0.784047,0,264.589,298.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-214.25,-214.249C-214.394,-214.249 -214.51,-118.318 -214.51,-0.01C-214.51,118.34 -214.394,214.25 -214.25,214.25C-214.105,214.25 -213.989,118.34 -213.989,-0.01C-213.989,-118.318 -214.105,-214.249 -214.25,-214.249",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "matrix(1.21068,0,0,1.21068,-122.954,-4.83037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,336.511,29.0123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,334.071L-113.503,334.004C-127.154,333.996 -138.216,322.925 -138.213,309.274L-138.158,24.72C-138.155,11.061 -127.078,-0.008 -113.418,0L0.085,0.067C13.735,0.075 24.797,11.145 24.794,24.796L24.738,309.351C24.735,323.01 13.658,334.079 0,334.071",
    style: {
      fill: "rgb(43,69,78)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,336.476,351.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-312.312L-22.007,-312.325C-24.958,-312.326 -27.352,-309.826 -27.352,-306.742L-27.353,-302.75C-27.353,-299.665 -29.746,-297.165 -32.697,-297.167L-75.592,-297.192C-78.543,-297.194 -80.936,-299.696 -80.935,-302.782L-80.934,-306.773C-80.934,-309.858 -83.325,-312.361 -86.277,-312.363L-94.016,-312.368L-113.277,-312.378C-122.843,-312.384 -130.601,-304.632 -130.603,-295.066L-130.657,-17.321C-130.659,-7.759 -122.912,-0.006 -113.352,0L-0.075,0.065C9.49,0.072 17.248,-7.68 17.25,-17.247L17.305,-294.993C17.307,-304.554 9.56,-312.306 0,-312.312",
    style: {
      fill: "rgb(250,250,250)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,632.336,-401.932)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.539,
    y: 450.084,
    width: 1.258,
    height: 1.764,
    style: {
      fill: "rgb(26,46,53)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,636.429,-402.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.586,
    y: 450.084,
    width: 1.257,
    height: 2.549,
    style: {
      fill: "rgb(26,46,53)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,640.523,-403.307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.633,
    y: 450.084,
    width: 1.257,
    height: 3.139,
    style: {
      fill: "rgb(26,46,53)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,644.619,-404.446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.681,
    y: 450.084,
    width: 1.257,
    height: 4.278,
    style: {
      fill: "rgb(26,46,53)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,341.393,49.7732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.582L-6.202,-3.581C-6.324,-3.581 -6.42,-3.484 -6.42,-3.36L-6.42,-0.222C-6.42,-0.1 -6.32,0 -6.198,0L0,0L0,-1.035C0,-1.099 0.052,-1.15 0.115,-1.15L0.791,-1.15L0.791,-2.432L0.115,-2.432C0.052,-2.432 0,-2.483 0,-2.547L0,-3.582ZM0.115,0.231L-6.198,0.231C-6.447,0.231 -6.65,0.028 -6.65,-0.222L-6.65,-3.36C-6.65,-3.61 -6.449,-3.812 -6.202,-3.812L0.115,-3.813C0.146,-3.813 0.176,-3.801 0.198,-3.779C0.22,-3.757 0.231,-3.728 0.231,-3.697L0.231,-2.663L0.907,-2.663C0.971,-2.663 1.022,-2.611 1.022,-2.547L1.022,-1.035C1.022,-0.971 0.971,-0.919 0.907,-0.919L0.231,-0.919L0.231,0.115C0.231,0.179 0.18,0.231 0.115,0.231",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,335.489,46.7071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.55L0,0L5.39,0L5.39,2.55L0,2.55Z",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,328.497,49.301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.462,-0.462C-0.207,-0.462 -0.001,-0.256 -0.001,-0.001C-0.001,0.254 -0.207,0.462 -0.462,0.462C-0.717,0.462 -0.923,0.254 -0.923,-0.001C-0.923,-0.256 -0.717,-0.462 -0.462,-0.462",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,326.923,48.5862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.064L0.589,0.653C0.842,0.401 1.189,0.245 1.574,0.245C1.958,0.245 2.307,0.401 2.559,0.653L3.147,0.064C2.744,-0.339 2.188,-0.589 1.574,-0.589C0.96,-0.589 0.403,-0.339 0,0.064",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,328.498,48.3119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.627C-0.976,-1.627 -1.86,-1.23 -2.502,-0.589L-1.913,0C-1.423,-0.49 -0.746,-0.794 0,-0.794C0.746,-0.794 1.422,-0.49 1.912,0L2.501,-0.589C1.86,-1.23 0.976,-1.627 0,-1.627",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,325.038,45.9185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.846L0.589,1.435C1.324,0.7 2.34,0.244 3.46,0.244C4.579,0.244 5.595,0.7 6.33,1.435L6.92,0.846C6.033,-0.04 4.809,-0.589 3.46,-0.589C2.11,-0.589 0.887,-0.04 0,0.846",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,287.378,73.6958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.075L-7.626,7.075C-8.148,7.075 -8.571,6.652 -8.571,6.129L-8.571,0.946C-8.571,0.424 -8.148,0 -7.626,0L0,0C0.522,0 0.946,0.424 0.946,0.946L0.946,6.129C0.946,6.652 0.522,7.075 0,7.075",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,280.906,69.2834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.878L-1,4.878L-1,3.697C-1,1.589 0.573,0 2.659,0C4.745,0 6.317,1.589 6.317,3.697L6.317,4.452L5.317,4.452L5.317,3.697C5.317,2.134 4.199,1 2.659,1C1.118,1 0,2.134 0,3.697L0,4.878Z",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,207.01,208.142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,40.746C-0.02,22.836 10.424,5.294 26.178,-3.226C37.218,-9.195 49.999,-10.781 62.232,-13.59C74.464,-16.398 87.137,-21.037 94.703,-31.05C104.924,-44.579 102.972,-63.809 110.346,-79.077C117.014,-92.88 131.695,-102.437 147.015,-102.947L147.015,129.554C147.015,137.363 140.684,143.693 132.875,143.693L14.139,143.693C6.331,143.693 0,137.363 0,129.554L0,40.746Z",
    style: {
      fill: "rgb(236,236,236)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,250.772,127.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C0,-7.23 -3.248,-11.213 -7.965,-11.213C-12.682,-11.213 -15.93,-7.23 -15.93,0C-15.93,7.23 -12.682,11.213 -7.965,11.213C-3.248,11.213 0,7.23 0,0M-18.752,0C-18.752,-8.622 -14.229,-13.765 -7.965,-13.765C-1.701,-13.765 2.862,-8.622 2.862,0C2.862,8.623 -1.701,13.765 -7.965,13.765C-14.229,13.765 -18.752,8.623 -18.752,0",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,273.311,133.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-11.214C0,-14.191 -2.475,-17.014 -7.153,-17.014C-11.059,-17.014 -13.765,-14.733 -13.765,-11.136C-13.765,-7.579 -11.136,-5.298 -6.96,-5.298C-2.822,-5.298 0,-7.85 0,-11.214M3.828,-5.839C3.828,3.363 -1.198,8.158 -8.545,8.158C-10.981,8.158 -13.263,7.732 -14.964,6.688L-13.843,4.446C-12.45,5.374 -10.595,5.722 -8.584,5.722C-2.745,5.722 1.005,1.971 1.005,-5.376C1.005,-5.994 0.967,-6.767 0.89,-7.579C-0.464,-4.602 -3.635,-2.94 -7.385,-2.94C-12.76,-2.94 -16.511,-6.11 -16.511,-11.059C-16.511,-16.125 -12.527,-19.372 -7.27,-19.372C-0.077,-19.372 3.828,-14.384 3.828,-5.839",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,281.196,122.958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.434C0,15.235 0.929,14.346 2.05,14.346C3.171,14.346 4.138,15.235 4.138,16.434C4.138,17.632 3.171,18.56 2.05,18.56C0.929,18.56 0,17.632 0,16.434M0,-0.038C0,-1.236 0.929,-2.126 2.05,-2.126C3.171,-2.126 4.138,-1.236 4.138,-0.038C4.138,1.161 3.171,2.089 2.05,2.089C0.929,2.089 0,1.161 0,-0.038",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,307.836,116.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.348L0,24.823L-18.985,24.823L-18.985,22.85L-7.733,11.831C-4.679,8.815 -4.099,6.998 -4.099,5.142C-4.099,2.01 -6.303,0.077 -10.44,0.077C-13.61,0.077 -16.047,1.043 -17.825,3.093L-19.797,1.391C-17.709,-1.084 -14.346,-2.475 -10.208,-2.475C-4.718,-2.475 -1.237,0.308 -1.237,4.832C-1.237,7.423 -2.05,9.743 -5.685,13.3L-14.887,22.348L0,22.348Z",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,329.912,127.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0C0,-7.23 -3.248,-11.213 -7.965,-11.213C-12.683,-11.213 -15.931,-7.23 -15.931,0C-15.931,7.23 -12.683,11.213 -7.965,11.213C-3.248,11.213 0,7.23 0,0M-18.753,0C-18.753,-8.622 -14.229,-13.765 -7.965,-13.765C-1.701,-13.765 2.861,-8.622 2.861,0C2.861,8.623 -1.701,13.765 -7.965,13.765C-14.229,13.765 -18.753,8.623 -18.753,0",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,233.628,69.7826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.54,-19.54C-30.332,-19.54 -39.08,-10.792 -39.08,0C-39.08,10.792 -30.332,19.54 -19.54,19.54C-8.748,19.54 0,10.792 0,0C0,-10.792 -8.748,-19.54 -19.54,-19.54",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Notifications",
    transform: "matrix(1.21068,0,0,1.21068,-122.954,-4.83037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,375.044,158.319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,65.061L-189.052,65.061C-192.887,65.061 -195.995,61.953 -195.995,58.118L-195.995,6.943C-195.995,3.108 -192.887,0 -189.052,0L0,0C3.834,0 6.942,3.108 6.942,6.943L6.942,58.118C6.942,61.953 3.834,65.061 0,65.061",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,375.044,158.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,65.004C-0.003,64.974 0.463,65.015 1.339,64.845C2.195,64.665 3.523,64.232 4.778,63.019C5.394,62.414 5.993,61.624 6.378,60.625C6.788,59.629 6.916,58.462 6.865,57.183C6.858,54.629 6.85,51.685 6.841,48.371C6.829,41.738 6.814,33.627 6.797,24.211C6.791,19.502 6.784,14.466 6.776,9.127C6.732,7.793 6.906,6.418 6.534,5.13C6.197,3.835 5.435,2.638 4.393,1.744C3.349,0.847 2.013,0.276 0.606,0.153C-0.807,0.093 -2.295,0.139 -3.769,0.127C-51.195,0.147 -116.694,0.173 -189.04,0.203C-190.13,0.208 -191.211,0.479 -192.174,0.979C-193.134,1.486 -193.955,2.239 -194.575,3.124C-195.181,4.021 -195.562,5.062 -195.689,6.132C-195.78,7.191 -195.715,8.354 -195.735,9.457C-195.735,13.924 -195.735,18.361 -195.736,22.767C-195.737,31.577 -195.739,40.258 -195.74,48.788C-195.74,50.921 -195.741,53.044 -195.741,55.157C-195.736,56.209 -195.754,57.277 -195.729,58.31C-195.692,59.322 -195.424,60.321 -194.953,61.213C-193.998,62.989 -192.225,64.307 -190.249,64.641C-189.277,64.815 -188.23,64.735 -187.199,64.754C-186.168,64.754 -185.139,64.755 -184.114,64.755C-175.908,64.758 -167.875,64.761 -160.037,64.764C-128.687,64.785 -100.455,64.804 -76.744,64.82C-53.04,64.855 -33.857,64.883 -20.59,64.902C-13.967,64.924 -8.822,64.941 -5.323,64.951C-3.585,64.963 -2.257,64.971 -1.353,64.978C-0.459,64.986 0,65.004 0,65.004C0,65.004 -0.459,65.022 -1.353,65.03C-2.257,65.037 -3.585,65.045 -5.323,65.057C-8.822,65.067 -13.967,65.084 -20.59,65.105C-33.857,65.125 -53.04,65.153 -76.744,65.188C-100.455,65.204 -128.687,65.223 -160.037,65.244C-167.875,65.247 -175.908,65.25 -184.114,65.253C-185.139,65.253 -186.168,65.254 -187.199,65.254C-188.225,65.233 -189.262,65.321 -190.338,65.133C-192.463,64.775 -194.371,63.361 -195.398,61.451C-195.905,60.492 -196.195,59.417 -196.235,58.328C-196.261,57.258 -196.243,56.217 -196.249,55.157C-196.249,53.044 -196.249,50.921 -196.25,48.788C-196.251,40.258 -196.253,31.577 -196.254,22.767C-196.254,18.361 -196.255,13.924 -196.255,9.457C-196.233,8.328 -196.304,7.249 -196.207,6.074C-196.07,4.92 -195.658,3.796 -195.004,2.831C-194.338,1.876 -193.453,1.066 -192.417,0.519C-191.38,-0.021 -190.212,-0.313 -189.04,-0.317C-116.694,-0.288 -51.195,-0.261 -3.769,-0.241C-2.28,-0.225 -0.838,-0.27 0.639,-0.204C2.118,-0.072 3.525,0.533 4.62,1.478C5.714,2.421 6.513,3.68 6.863,5.043C7.062,5.717 7.106,6.429 7.11,7.109C7.109,7.787 7.108,8.459 7.108,9.127C7.101,14.466 7.095,19.502 7.088,24.211C7.07,33.627 7.056,41.738 7.044,48.371C7.035,51.685 7.026,54.629 7.02,57.183C7.063,58.452 6.925,59.671 6.499,60.674C6.099,61.688 5.481,62.486 4.851,63.094C3.565,64.314 2.216,64.733 1.35,64.898C0.905,64.968 0.568,65.005 0.341,65C0.114,65.007 0,65.004 0,65.004",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,367.375,166.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.314C-0.065,5.314 -0.132,5.288 -0.181,5.237C-0.276,5.137 -0.272,4.979 -0.173,4.883L4.828,0.094C4.929,0 5.086,0.001 5.182,0.102C5.277,0.201 5.273,0.359 5.174,0.455L0.173,5.245C0.124,5.291 0.062,5.314 0,5.314",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,372.35,166.337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.357C-0.062,5.357 -0.126,5.334 -0.175,5.286L-5.125,0.455C-5.224,0.359 -5.226,0.201 -5.129,0.102C-5.033,0.004 -4.875,0 -4.775,0.098L0.175,4.928C0.273,5.024 0.275,5.183 0.179,5.282C0.13,5.332 0.065,5.357 0,5.357",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,222.782,173.163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,30.327L-2.041,27.437C-3.271,25.695 -3.932,23.615 -3.933,21.482L-3.935,14.988C-3.937,9.683 -7.835,5.291 -12.922,4.515L-12.923,1.416C-12.923,0.628 -13.563,-0.01 -14.351,-0.01C-15.138,-0.009 -15.777,0.629 -15.776,1.417L-15.775,4.469C-21.043,5.085 -25.131,9.562 -25.129,14.995L-25.127,21.723C-25.126,24.036 -25.901,26.282 -27.329,28.102L-29.082,30.337L0,30.327Z",
    style: {
      fill: "rgb(255,166,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.407731,0.913102,0.913102,-0.407731,206.787,206.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.962,-0.96C3.2,0.202 3.685,2.102 3.155,3.716C2.923,4.422 2.503,5.055 1.962,5.564L-1.547,-2.146C-0.281,-2.255 1.034,-1.832 1.962,-0.96",
    style: {
      fill: "rgb(255,166,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,286.18,129.528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50.772,-50.772C-50.916,-50.772 -51.032,-28.04 -51.032,-0.002C-51.032,28.043 -50.916,50.772 -50.772,50.772C-50.628,50.772 -50.512,28.043 -50.512,-0.002C-50.512,-28.04 -50.628,-50.772 -50.772,-50.772",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,298.144,129.853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-62.736,-62.736C-62.88,-62.736 -62.996,-34.646 -62.996,-0.003C-62.996,34.652 -62.88,62.736 -62.736,62.736C-62.592,62.736 -62.476,34.652 -62.476,-0.003C-62.476,-34.646 -62.592,-62.736 -62.736,-62.736",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,298.144,137.212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-62.736,-62.736C-62.88,-62.736 -62.996,-34.646 -62.996,-0.003C-62.996,34.652 -62.88,62.736 -62.736,62.736C-62.592,62.736 -62.476,34.652 -62.476,-0.003C-62.476,-34.646 -62.592,-62.736 -62.736,-62.736",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,342.576,233.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.702L-125.547,44.702C-129.382,44.702 -132.49,41.594 -132.49,37.759L-132.49,6.943C-132.49,3.108 -129.382,0 -125.547,0L0,0C3.834,0 6.942,3.108 6.942,6.943L6.942,37.759C6.942,41.594 3.834,44.702 0,44.702",
    style: {
      fill: "rgb(250,250,250)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,342.576,233.575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.664C-0.001,44.645 0.312,44.651 0.913,44.57C1.508,44.489 2.413,44.292 3.43,43.691C4.432,43.099 5.587,42.086 6.275,40.498C6.618,39.713 6.839,38.798 6.849,37.81C6.846,36.811 6.844,35.748 6.841,34.621C6.829,30.109 6.814,24.595 6.797,18.194C6.791,14.992 6.784,11.568 6.776,7.937C6.778,7.023 6.795,6.119 6.557,5.236C6.332,4.355 5.922,3.508 5.349,2.77C4.217,1.282 2.39,0.27 0.424,0.168C-31.825,0.182 -76.356,0.201 -125.539,0.223C-127.017,0.24 -128.497,0.71 -129.648,1.636C-130.807,2.54 -131.667,3.826 -132.014,5.247C-132.203,5.963 -132.247,6.67 -132.23,7.438L-132.23,9.705C-132.231,11.213 -132.231,12.716 -132.231,14.213C-132.232,20.204 -132.234,26.106 -132.235,31.906C-132.235,33.356 -132.236,34.8 -132.236,36.237C-132.231,36.951 -132.255,37.686 -132.205,38.362C-132.13,39.048 -131.961,39.719 -131.699,40.353C-131.149,41.608 -130.228,42.698 -129.065,43.405C-127.912,44.138 -126.555,44.459 -125.188,44.415C-119.608,44.418 -114.146,44.421 -108.817,44.424C-87.502,44.444 -68.307,44.464 -52.182,44.479C-36.069,44.515 -23.028,44.543 -14,44.562C-9.502,44.583 -6.006,44.6 -3.62,44.611C-2.442,44.622 -1.542,44.631 -0.92,44.637C-0.312,44.645 0,44.664 0,44.664C0,44.664 -0.312,44.682 -0.92,44.69C-1.542,44.696 -2.442,44.705 -3.62,44.716C-6.006,44.727 -9.502,44.744 -14,44.765C-23.028,44.784 -36.069,44.812 -52.182,44.848C-68.307,44.863 -87.502,44.883 -108.817,44.903C-114.146,44.906 -119.608,44.909 -125.188,44.912C-126.602,44.962 -128.101,44.617 -129.33,43.831C-130.579,43.072 -131.57,41.902 -132.162,40.552C-132.446,39.87 -132.628,39.147 -132.708,38.41C-132.764,37.659 -132.737,36.96 -132.744,36.237C-132.745,34.8 -132.745,33.356 -132.745,31.906C-132.747,26.106 -132.748,20.204 -132.749,14.213C-132.749,12.716 -132.749,11.213 -132.75,9.705L-132.75,7.438C-132.768,6.693 -132.721,5.872 -132.518,5.119C-132.143,3.585 -131.216,2.2 -129.968,1.226C-128.728,0.229 -127.129,-0.282 -125.539,-0.298C-76.348,-0.26 -31.809,-0.225 0.446,-0.2C2.52,-0.086 4.441,0.988 5.626,2.556C6.226,3.334 6.654,4.226 6.887,5.152C7.135,6.081 7.112,7.041 7.108,7.937C7.101,11.568 7.095,14.992 7.088,18.194C7.07,24.595 7.056,30.109 7.044,34.621C7.038,35.749 7.032,36.812 7.027,37.812C7.01,38.825 6.775,39.762 6.416,40.56C5.697,42.178 4.508,43.195 3.482,43.782C2.44,44.378 1.521,44.559 0.92,44.623C0.313,44.686 0,44.664 0,44.664",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,339.479,238.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.816C-0.065,3.816 -0.132,3.79 -0.181,3.739C-0.276,3.639 -0.272,3.481 -0.173,3.385L3.263,0.094C3.363,0 3.521,0.003 3.616,0.102C3.712,0.202 3.708,0.36 3.608,0.456L0.173,3.747C0.124,3.793 0.062,3.816 0,3.816",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,342.898,238.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.845C-0.062,3.845 -0.126,3.822 -0.175,3.774L-3.576,0.455C-3.675,0.359 -3.677,0.2 -3.58,0.101C-3.484,0.004 -3.326,0 -3.227,0.097L0.175,3.416C0.273,3.512 0.275,3.671 0.179,3.77C0.13,3.82 0.065,3.845 0,3.845",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,240.134,243.736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.837L-1.402,18.851C-2.248,17.654 -2.702,16.225 -2.702,14.76L-2.704,10.298C-2.705,6.653 -5.383,3.635 -8.878,3.103L-8.879,0.973C-8.879,0.432 -9.318,-0.007 -9.86,-0.007C-10.401,-0.007 -10.84,0.432 -10.84,0.974L-10.839,3.07C-14.458,3.494 -17.267,6.569 -17.266,10.302L-17.264,14.925C-17.264,16.515 -17.796,18.058 -18.777,19.308L-19.981,20.844L0,20.837Z",
    style: {
      fill: "rgb(55,90,100)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.407608,0.913157,0.913157,-0.407608,229.144,266.317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.348,-0.66C2.198,0.139 2.531,1.445 2.167,2.553C2.008,3.037 1.719,3.474 1.348,3.822L-1.063,-1.476C-0.194,-1.55 0.71,-1.259 1.348,-0.66",
    style: {
      fill: "rgb(55,90,100)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,283.693,213.754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-34.885,-34.884C-35.029,-34.884 -35.145,-19.264 -35.145,-0.002C-35.145,19.267 -35.029,34.885 -34.885,34.885C-34.741,34.885 -34.624,19.267 -34.624,-0.002C-34.624,-19.264 -34.741,-34.884 -34.885,-34.884",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,291.913,213.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-43.103,-43.105C-43.249,-43.105 -43.365,-23.805 -43.365,-0.002C-43.365,23.808 -43.249,43.103 -43.103,43.103C-42.96,43.103 -42.844,23.808 -42.844,-0.002C-42.844,-23.805 -42.96,-43.105 -43.103,-43.105",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,291.913,219.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-43.103,-43.105C-43.249,-43.105 -43.365,-23.805 -43.365,-0.002C-43.365,23.808 -43.249,43.103 -43.103,43.103C-42.96,43.103 -42.844,23.808 -42.844,-0.002C-42.844,-23.805 -42.96,-43.105 -43.103,-43.105",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,342.048,285.194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.364L-124.495,44.364C-128.329,44.364 -131.437,41.256 -131.437,37.422L-131.437,6.942C-131.437,3.108 -128.329,0 -124.495,0L0,0C3.835,0 6.943,3.108 6.943,6.942L6.943,37.422C6.943,41.256 3.835,44.364 0,44.364",
    style: {
      fill: "rgb(250,250,250)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,342.048,285.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.378C-0.001,44.36 0.312,44.364 0.906,44.285C1.497,44.207 2.394,44.01 3.406,43.42C4.404,42.836 5.553,41.837 6.249,40.269C6.596,39.492 6.824,38.587 6.845,37.608C6.844,36.617 6.843,35.562 6.842,34.445C6.829,29.968 6.814,24.496 6.798,18.146C6.791,14.968 6.784,11.571 6.777,7.969C6.779,7.062 6.794,6.165 6.558,5.289C6.335,4.415 5.929,3.574 5.363,2.84C4.244,1.363 2.443,0.341 0.492,0.223C-31.506,0.236 -75.688,0.254 -124.486,0.274C-127.45,0.234 -130.249,2.387 -130.945,5.232C-131.146,5.939 -131.189,6.646 -131.178,7.4L-131.178,9.649C-131.178,11.146 -131.179,12.637 -131.179,14.123C-131.18,20.066 -131.181,25.924 -131.183,31.678C-131.183,33.117 -131.184,34.549 -131.184,35.975C-131.179,36.684 -131.202,37.412 -131.152,38.083C-131.077,38.764 -130.91,39.429 -130.65,40.059C-130.106,41.306 -129.196,42.388 -128.049,43.099C-126.907,43.826 -125.564,44.166 -124.211,44.129C-118.675,44.132 -113.256,44.135 -107.968,44.138C-86.819,44.159 -67.773,44.178 -51.774,44.194C-35.787,44.229 -22.849,44.257 -13.891,44.276C-9.428,44.298 -5.959,44.315 -3.591,44.325C-2.423,44.337 -1.529,44.346 -0.912,44.352C-0.309,44.36 0,44.378 0,44.378C0,44.378 -0.309,44.396 -0.912,44.404C-1.529,44.41 -2.423,44.419 -3.591,44.431C-5.959,44.441 -9.428,44.458 -13.891,44.48C-22.849,44.499 -35.787,44.527 -51.774,44.563C-67.773,44.578 -86.819,44.597 -107.968,44.618C-113.256,44.621 -118.675,44.624 -124.211,44.627C-125.621,44.668 -127.097,44.304 -128.315,43.523C-129.549,42.76 -130.529,41.599 -131.114,40.257C-131.394,39.58 -131.575,38.863 -131.655,38.132C-131.71,37.387 -131.685,36.691 -131.691,35.975C-131.692,34.549 -131.692,33.117 -131.693,31.678C-131.694,25.924 -131.695,20.066 -131.697,14.123L-131.697,9.649L-131.698,7.4C-131.71,6.655 -131.664,5.845 -131.447,5.099C-130.696,2.029 -127.681,-0.29 -124.486,-0.247C-75.678,-0.207 -31.485,-0.171 0.519,-0.144C2.576,-0.013 4.469,1.07 5.641,2.627C6.233,3.4 6.657,4.286 6.888,5.206C7.133,6.127 7.113,7.08 7.108,7.969C7.102,11.571 7.095,14.968 7.089,18.146C7.071,24.496 7.057,29.968 7.044,34.445C7.037,35.564 7.03,36.62 7.023,37.612C6.995,38.617 6.753,39.542 6.39,40.332C5.662,41.93 4.479,42.933 3.459,43.511C2.422,44.095 1.511,44.276 0.913,44.338C0.312,44.4 0,44.378 0,44.378",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,339.027,290.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.789C-0.065,3.789 -0.132,3.764 -0.181,3.712C-0.276,3.612 -0.272,3.454 -0.173,3.358L3.237,0.093C3.338,0 3.496,0 3.591,0.101C3.687,0.2 3.683,0.358 3.583,0.454L0.173,3.72C0.124,3.766 0.062,3.789 0,3.789",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,342.42,290.574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.82C-0.062,3.82 -0.126,3.797 -0.175,3.749L-3.55,0.455C-3.648,0.358 -3.65,0.2 -3.554,0.101C-3.457,0.005 -3.299,0 -3.2,0.097L0.175,3.391C0.273,3.488 0.275,3.646 0.179,3.745C0.13,3.795 0.065,3.82 0,3.82",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,240.431,295.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.68L-1.392,18.709C-2.23,17.521 -2.681,16.103 -2.682,14.649L-2.683,10.22C-2.684,6.603 -5.343,3.608 -8.812,3.079L-8.812,0.966C-8.813,0.429 -9.248,-0.007 -9.785,-0.007C-10.323,-0.007 -10.758,0.429 -10.758,0.966L-10.757,3.047C-14.349,3.468 -17.136,6.52 -17.135,10.225L-17.134,14.813C-17.133,16.39 -17.662,17.921 -18.635,19.162L-19.831,20.687L0,20.68Z",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.407577,0.913171,0.913171,-0.407577,229.525,317.726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.338,-0.655C2.181,0.138 2.512,1.433 2.15,2.534C1.993,3.014 1.706,3.447 1.338,3.793L-1.054,-1.465C-0.192,-1.538 0.706,-1.25 1.338,-0.655",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,283.661,265.561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-34.621,-34.621C-34.765,-34.621 -34.882,-19.12 -34.882,-0.003C-34.882,19.121 -34.765,34.621 -34.621,34.621C-34.477,34.621 -34.36,19.121 -34.36,-0.003C-34.36,-19.12 -34.477,-34.621 -34.621,-34.621",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,291.819,265.783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42.778,-42.779C-42.923,-42.779 -43.039,-23.625 -43.039,-0.003C-43.039,23.628 -42.923,42.778 -42.778,42.778C-42.634,42.778 -42.518,23.628 -42.518,-0.003C-42.518,-23.625 -42.634,-42.779 -42.778,-42.779",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,291.819,270.801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42.778,-42.779C-42.922,-42.779 -43.039,-23.625 -43.039,-0.003C-43.039,23.628 -42.922,42.778 -42.778,42.778C-42.634,42.778 -42.518,23.628 -42.518,-0.003C-42.518,-23.625 -42.634,-42.779 -42.778,-42.779",
    style: {
      fill: "rgb(225,225,225)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "matrix(1.21068,0,0,1.21068,-113.735,-103.985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.46,387.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-114.274C-10.353,-108.911 -18.291,-99.678 -23.999,-89.512C-29.707,-79.346 -33.386,-68.191 -37.03,-57.117L-40.219,0C-28.173,-20.493 -18.504,-44.583 -15.893,-68.21C-18.564,-68.448 -21.236,-68.686 -23.908,-68.923C-18.533,-69.744 -14.022,-73.638 -11.151,-78.255C-8.281,-82.874 -6.804,-88.198 -5.361,-93.44C-8.622,-92.956 -11.882,-92.471 -15.142,-91.986C-7.483,-97.098 -1.931,-105.27 0,-114.274",
    style: {
      fill: "rgb(55,90,100)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.46,387.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-114.274C-10.353,-108.911 -18.291,-99.678 -23.999,-89.512C-29.707,-79.346 -33.386,-68.191 -37.03,-57.117L-40.219,0C-28.173,-20.493 -18.504,-44.583 -15.893,-68.21C-18.564,-68.448 -21.236,-68.686 -23.908,-68.923C-18.533,-69.744 -14.022,-73.638 -11.151,-78.255C-8.281,-82.874 -6.804,-88.198 -5.361,-93.44C-8.622,-92.956 -11.882,-92.471 -15.142,-91.986C-7.483,-97.098 -1.931,-105.27 0,-114.274",
    style: {
      fill: "rgb(91,204,172)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,444.46,387.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-114.274C-10.353,-108.911 -18.291,-99.678 -23.999,-89.512C-29.707,-79.346 -33.386,-68.191 -37.03,-57.117L-40.219,0C-28.173,-20.493 -18.504,-44.583 -15.893,-68.21C-18.564,-68.448 -21.236,-68.686 -23.908,-68.923C-18.533,-69.744 -14.022,-73.638 -11.151,-78.255C-8.281,-82.874 -6.804,-88.198 -5.361,-93.44C-8.622,-92.956 -11.882,-92.471 -15.142,-91.986C-7.483,-97.098 -1.931,-105.27 0,-114.274",
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,402.458,268.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,132.385C0,132.385 -26.146,101.09 -25.844,71.216L-15.282,71.216C-15.282,71.216 -26.754,63.672 -25.847,59.447C-24.938,55.223 -24.637,39.229 -24.637,39.229L-14.98,41.643C-14.98,41.643 -22.223,38.022 -23.128,32.288C-24.033,26.555 -21.016,0 -21.016,0C-21.016,0 -9.247,12.372 -5.626,25.046C-2.005,37.72 7.501,52.507 4.709,91.132C1.918,129.758 0,132.385 0,132.385",
    style: {
      fill: "rgb(91,204,172)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,415.712,302.077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,101.267C0,101.267 28.326,82.397 34.62,58.312L26.129,56.001C26.129,56.001 37.003,52.446 37.197,48.851C37.392,45.256 40.647,32.331 40.647,32.331L32.356,32.16C32.356,32.16 38.971,30.833 40.953,26.421C42.936,22.01 46.319,0 46.319,0C46.319,0 34.15,7.372 28.467,16.77C22.782,26.167 11.905,35.975 5.699,67.64C-0.508,99.304 0,101.267 0,101.267",
    style: {
      fill: "rgb(91,204,172)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,388.585,424.798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-129.508C0.01,-129.511 0.042,-129.401 0.098,-129.185C0.156,-128.938 0.232,-128.62 0.328,-128.222C0.528,-127.336 0.808,-126.093 1.165,-124.51C1.529,-122.898 1.952,-120.921 2.411,-118.619C2.879,-116.32 3.423,-113.702 3.954,-110.795C5.077,-104.993 6.262,-98.057 7.479,-90.339C8.66,-82.615 9.839,-74.105 10.885,-65.15C11.91,-56.188 12.704,-47.631 13.317,-39.841C13.892,-32.047 14.322,-25.023 14.553,-19.117C14.698,-16.166 14.765,-13.494 14.835,-11.149C14.914,-8.803 14.952,-6.781 14.965,-5.129C14.979,-3.507 14.99,-2.233 14.998,-1.324C14.996,-0.915 14.994,-0.588 14.992,-0.335C14.988,-0.112 14.981,0.002 14.972,0.003C14.962,0.003 14.95,-0.112 14.936,-0.334C14.923,-0.587 14.906,-0.913 14.885,-1.322C14.853,-2.23 14.806,-3.503 14.747,-5.124C14.701,-6.775 14.63,-8.794 14.522,-11.138C14.422,-13.482 14.327,-16.151 14.157,-19.099C13.876,-24.998 13.405,-32.015 12.803,-39.8C12.162,-47.582 11.353,-56.13 10.328,-65.085C9.283,-74.033 8.121,-82.539 6.97,-90.261C5.78,-97.977 4.638,-104.916 3.565,-110.724C3.059,-113.633 2.542,-116.253 2.104,-118.559C1.675,-120.865 1.282,-122.847 0.951,-124.465C0.639,-126.058 0.394,-127.308 0.218,-128.198C0.145,-128.602 0.087,-128.923 0.041,-129.172C0.005,-129.393 -0.01,-129.506 0,-129.508",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,398.832,346.533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,73.02C0,73.02 -23.927,45.873 -31.356,29.461L-25.748,27.065C-29.812,27.736 -33.978,25.989 -37.13,23.335C-40.282,20.682 -42.598,17.192 -44.867,13.753L-37.479,12.505C-44.197,10.62 -50.116,6.035 -53.621,0C-44.902,1.434 -37.016,6.223 -30.516,12.208C-25.252,17.055 -20.795,22.682 -16.515,28.431C-14.427,31.236 -12.6,34.224 -11.077,37.372C-7.057,45.683 0.014,63.05 0,73.02",
    style: {
      fill: "rgb(91,204,172)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,450.709,424.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-106.921C0.009,-106.916 -0.027,-106.822 -0.107,-106.643C-0.202,-106.435 -0.322,-106.175 -0.472,-105.852C-0.821,-105.125 -1.307,-104.116 -1.922,-102.837C-3.201,-100.229 -5.015,-96.437 -7.211,-91.731C-11.607,-82.321 -17.401,-69.189 -23.123,-54.41C-28.833,-39.623 -33.382,-26.007 -36.458,-16.087C-37.999,-11.128 -39.209,-7.103 -40.017,-4.313C-40.422,-2.952 -40.741,-1.88 -40.972,-1.107C-41.079,-0.767 -41.165,-0.494 -41.233,-0.276C-41.296,-0.09 -41.332,0.004 -41.342,0.002C-41.351,-0.001 -41.333,-0.101 -41.289,-0.291C-41.234,-0.513 -41.166,-0.791 -41.081,-1.137C-40.875,-1.917 -40.589,-2.999 -40.227,-4.372C-39.482,-7.181 -38.33,-11.226 -36.837,-16.203C-33.855,-26.159 -29.361,-39.81 -23.646,-54.612C-17.918,-69.405 -12.061,-82.527 -7.568,-91.9C-5.325,-96.587 -3.457,-100.355 -2.117,-102.934C-1.462,-104.194 -0.945,-105.187 -0.572,-105.902C-0.403,-106.216 -0.267,-106.468 -0.158,-106.668C-0.062,-106.84 -0.009,-106.925 0,-106.921",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400.861,384.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,46.417C-0.02,46.419 -0.061,46.247 -0.122,45.919C-0.187,45.524 -0.267,45.05 -0.362,44.479C-0.548,43.227 -0.863,41.42 -1.305,39.201C-1.737,36.98 -2.354,34.357 -3.14,31.473C-3.95,28.596 -4.943,25.46 -6.152,22.23C-7.381,19.004 -8.708,15.995 -10.001,13.299C-11.319,10.615 -12.59,8.238 -13.732,6.286C-14.868,4.329 -15.824,2.766 -16.513,1.702C-16.818,1.211 -17.073,0.802 -17.284,0.463C-17.455,0.176 -17.537,0.02 -17.521,0.009C-17.506,-0.002 -17.393,0.133 -17.19,0.399C-16.956,0.723 -16.672,1.112 -16.331,1.581C-15.586,2.609 -14.575,4.146 -13.392,6.084C-12.2,8.019 -10.888,10.387 -9.538,13.071C-8.212,15.769 -6.863,18.788 -5.629,22.031C-4.412,25.28 -3.429,28.438 -2.642,31.337C-1.88,34.244 -1.3,36.889 -0.916,39.128C-0.522,41.364 -0.266,43.186 -0.146,44.449C-0.092,45.027 -0.047,45.507 -0.01,45.905C0.016,46.238 0.02,46.414 0,46.417",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,812.498,360.284)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.066,
    y: 64.517,
    width: 52.366,
    height: 10.682,
    style: {
      fill: "rgb(43,69,78)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.15574,0.987798,0.987798,-0.15574,420.779,429.616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.231,-36.202L36.606,-36.202L41.534,-4.945L6.864,5.867L0.231,-36.202Z",
    style: {
      fill: "rgb(43,69,78)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,407.096,413.358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22.125,-22.125C-22.28,-22.125 -22.405,-12.219 -22.405,-0C-22.405,12.22 -22.28,22.125 -22.125,22.125C-21.971,22.125 -21.845,12.22 -21.845,-0C-21.845,-12.219 -21.971,-22.125 -22.125,-22.125",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Speech-Bubble",
    transform: "matrix(1.21068,0,0,1.21068,-122.954,-4.83037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.527,22.5565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72.4L1.089,59.479C-3.406,56.491 -7.157,52.264 -9.583,47.003C-16.56,31.873 -9.95,13.953 5.179,6.977C20.309,0 38.229,6.609 45.205,21.739C52.181,36.868 45.572,54.789 30.443,61.765C24.125,64.678 17.323,65.215 11.032,63.759L11.047,63.767L0,72.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,440.527,26.5545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,68.402C0.526,67.996 4.037,65.29 11.104,59.842L11.218,59.755L11.091,59.687L11.076,59.679L11.012,59.852C13.133,60.341 15.554,60.671 18.213,60.651C20.867,60.611 23.759,60.246 26.717,59.331C28.19,58.867 29.697,58.312 31.157,57.55C31.884,57.164 32.635,56.795 33.372,56.378C34.081,55.912 34.798,55.439 35.526,54.96C38.347,52.917 40.976,50.276 43.088,47.076C45.202,43.882 46.794,40.135 47.582,36.07C48.368,32.013 48.364,27.633 47.332,23.348C46.294,19.071 44.292,14.899 41.387,11.306C38.481,7.731 34.718,4.665 30.316,2.744L28.629,2.029C28.07,1.784 27.474,1.646 26.9,1.449C26.317,1.282 25.753,1.049 25.158,0.939L23.39,0.562C22.805,0.414 22.208,0.353 21.613,0.289C21.018,0.221 20.425,0.153 19.833,0.086C19.238,0.074 18.644,0.062 18.052,0.05C17.459,0.05 16.868,0 16.281,0.074C11.572,0.33 7.049,1.686 3.126,3.851C-0.798,6.015 -4.145,8.971 -6.612,12.383C-9.096,15.784 -10.769,19.569 -11.665,23.346C-12.566,27.129 -12.692,30.899 -12.238,34.387C-11.771,37.886 -10.626,41.042 -9.319,43.849C-7.937,46.631 -6.227,48.991 -4.429,50.925C-2.627,52.862 -0.738,54.372 1.039,55.555L1,55.473C0.361,63.732 0.049,67.768 0,68.402C0.058,67.769 0.425,63.737 1.178,55.488L1.183,55.436L1.138,55.406C-0.621,54.218 -2.488,52.708 -4.267,50.776C-6.042,48.847 -7.729,46.498 -9.088,43.735C-10.373,40.945 -11.498,37.815 -11.95,34.348C-12.389,30.893 -12.255,27.161 -11.354,23.421C-10.46,19.684 -8.798,15.944 -6.336,12.585C-3.892,9.215 -0.58,6.3 3.3,4.165C7.179,2.029 11.648,0.694 16.299,0.443C16.879,0.37 17.464,0.42 18.048,0.42C18.633,0.432 19.22,0.444 19.808,0.456C20.393,0.523 20.979,0.589 21.565,0.657C22.154,0.72 22.744,0.78 23.321,0.927L25.068,1.299C25.656,1.408 26.213,1.64 26.789,1.804C27.355,1.999 27.944,2.135 28.496,2.377L30.163,3.084C34.511,4.98 38.228,8.009 41.1,11.538C43.971,15.085 45.953,19.207 46.982,23.431C48.007,27.664 48.016,31.992 47.245,36.006C46.473,40.026 44.905,43.735 42.82,46.899C40.737,50.07 38.142,52.69 35.354,54.721C34.635,55.198 33.925,55.668 33.226,56.131C32.497,56.548 31.753,56.915 31.034,57.3C29.59,58.06 28.098,58.615 26.64,59.081C23.711,59.998 20.844,60.373 18.21,60.424C15.572,60.458 13.165,60.144 11.053,59.671L10.989,59.843L11.004,59.851L10.99,59.696C3.995,65.237 0.521,67.989 0,68.402",
    style: {
      fill: "rgb(26,46,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,454.064,59.5204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-17.976L0.936,-0.419C1.013,1.016 2.147,2.17 3.582,2.27C5.094,2.375 6.424,1.275 6.605,-0.23L8.729,-17.845C8.89,-19.179 7.845,-20.351 6.502,-20.346L2.222,-20.329C0.945,-20.324 -0.068,-19.251 0,-17.976",
    style: {
      fill: "rgb(91,204,172)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.315107,-0.949056,-0.949056,-0.315107,460.738,65.8374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.065,-2.933C-6.43,-2.933 -8.347,-1.016 -8.347,1.349C-8.348,3.715 -6.43,5.632 -4.065,5.632C-1.7,5.632 0.218,3.715 0.218,1.35C0.217,-1.015 -1.699,-2.933 -4.065,-2.933",
    style: {
      fill: "rgb(91,204,172)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNews);
export default __webpack_public_path__ + "static/media/header-news.49f2f481388f1ae12673618e90f00e00.svg";
export { ForwardRef as ReactComponent };